import type { LazyRouteFunction } from '@remix-run/router';
import type { RouteObject } from 'react-router/dist/lib/context';

import { NavigationAside } from '@component/aside/navigation/navigation.aside';
import { Header } from '@component/header/header';
import { RouteEnum } from '@enum/route.enum';
import { RouteConfigInterface } from '@interface/route/route.interface';
import { pageLazyLoader } from '@util/route/page-lazy-loader';
import { pageNameLoader } from '@util/route/page-name-loader';

export const ConnectorRoutes: RouteConfigInterface[] = [
  {
    Header,
    Aside: NavigationAside,
    lazy: (() => pageLazyLoader(import('@page/integrations/integrations.page'))) as LazyRouteFunction<RouteObject>,
    ...pageNameLoader(RouteEnum.Integrations),
  },
  {
    Header,
    Aside: NavigationAside,
    lazy: (() =>
      pageLazyLoader(import('@page/integration-view/integration-view.page'))) as LazyRouteFunction<RouteObject>,
    ...pageNameLoader(RouteEnum.IntegrationView),
  },
];
